module.exports = __webpack_public_path__ + "static/media/teamWork.e8ac2010.png";